import { render, staticRenderFns } from "./RejectIcon.vue?vue&type=template&id=2cdbb6ae"
import script from "./RejectIcon.vue?vue&type=script&lang=js"
export * from "./RejectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports